import {
  ChangeDetectionStrategy,
  Component, Input, OnDestroy, OnInit
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

import { ConfigurationService, IDirectoryAppConfig } from '@sondermind/configuration';
import {
  EmptyURIValue,
  URIPrefix,
} from '@sondermind/data-access/directory-link';
import { WindowRefService } from '@sondermind/utilities/window';

import { InfoLinks } from '@sondermind/core/enums/info-links.enum';

/**
 * This footer is used in public-facing applications like the
 * provider-landing-page and provider-directory.
 */
@Component({
  selector: 'public-footer',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './public-footer.component.html',
  styleUrls: ['./public-footer.component.scss']
})
export class PublicFooterComponent implements OnInit, OnDestroy {
  emergencyResources = InfoLinks.EMERGENCY_RESOURCES;
  destroyed$ = new Subject<void>();

  @Input() matchflowBaseUrl: string = '';

  emptyUriValue = EmptyURIValue;
  uriPrefix = URIPrefix;
  therapyMatchFlowUrl: string = '';
  psychiatryMatchFlowUrl: string = '';
  providerDirectoryUrl: string = '';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  MAX_INSURANCES: number = 5;
  private anonUserId: string = '';

  constructor(
    private route: ActivatedRoute,
    private configurationService: ConfigurationService<IDirectoryAppConfig>,
    private windowRef: WindowRefService,
  ) {}

  ngOnInit(): void {
    const referringUrl = encodeURIComponent(this.windowRef.nativeWindow?.location.href || 'localhost:4206');
    this.therapyMatchFlowUrl = `${this.matchflowBaseUrl}?referringUrl=${referringUrl}`;
    this.psychiatryMatchFlowUrl = `${this.matchflowBaseUrl}/?slug=psychiatry-flow&referringUrl=${referringUrl}`;
    this.providerDirectoryUrl = this.configurationService.env.providerDirectoryBase
                                || 'https://www.sondermind.com/provider-directory';

    this.route.queryParams.pipe(
      takeUntil(this.destroyed$)
    ).subscribe((queryParams) => {
      if (queryParams['anonUserId']) {
        this.anonUserId = queryParams['anonUserId'] as string;
        this.therapyMatchFlowUrl = `${this.therapyMatchFlowUrl}&anonUserId=${this.anonUserId}`;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
